<template>
 
    <nav>
      <van-tabbar class="active_tab" fixed border v-model="selected"  @change="chooseTabbar" >
        <van-tabbar-item  v-for="item in navDatas" :key="item.value">
          <span>{{ item.name }}</span>
          <template #icon="props">
            <img class="img" :src="props.active ? item.imgActive:item.img" />
         </template>
        </van-tabbar-item>
      </van-tabbar>
    </nav>
 
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
export default {
  name: 'el-nav',
  props: {},

  data() {
    return {
       navDatas: [
        {
          name: "首页",
          link: "index",
          value: "0",
          icon: "index",
          img: require("../../assets/nav/index_icon.png"),
          imgActive: require("../../assets/nav/index_icon_active.png"),
          url: "/index",
          active: true 
        },
        {
          name: "分类",
          link: "category",
          value: "1",
          icon: "course",
          img: require("../../assets/nav/class_icon.png"),
          imgActive: require("../../assets/nav/class_icon_active.png"),
          url: "/category",
          active: false
        },
        {
          name: "购物车",
          link: "shopping-car",
          value: "2",
          icon: "mall",
          img: require("../../assets/nav/cart_icon.png"),
          imgActive: require("../../assets/nav/cart_icon_active.png"),
          url: "/shopping-car",
          active: false
        },
        {
          name: "我的",
          link: "mine",
          value: "3",
          icon: "my",
          img: require("../../assets/nav/mine_icon.png"),
          imgActive: require("../../assets/nav/mine_icon_active.png"),
          url: "/mine",
          active: false
        }
      ],
      selected: 0
    }
  },
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
    watch: {
    $route(to, from) {
      // console.log(to)
     if (to.name == "index") {
        this.selected = 0;
      } else if (to.name == "category") {
        this.selected = 1; 
      } else if (to.name == "shopping-car") {
        this.selected = 2;
      } else if (to.name == "mine") {
        this.selected = 3;
      } else {
        this.selected = 0;
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
      chooseTabbar(index) {
      //  if (!this.isLogin()) return false;
       this.selected = index;
      //  console.log(index,'121')
      this.$router.push({ path: this.navDatas[index].url });
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/index.scss';
 .active_tab{
   height: 50px;
   font-size: $fSTips;
 }
 .active_tab .img {
  width: 24px;
  height: 24px;
} 

.van-tabbar-item--active {
  color: $navActive;
}
</style>
